/* eslint-disable no-return-await */
import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/notFound'
import shopDetail from '../pages/shopDetail/router'
import shopDetailBR from '../pages-BR/shopDetail/router'
import shopDetailJP from '../pages-JP/shopDetail/router'
import shopDetailCOM from '../pages-COM/shopDetail/router'
import { defaultExistTag } from '@/mainConf/utils'
import { canOpenPageForNewWebview } from '@/common/utils/bridge'
import { initXRouter } from '@didi/sailing-x-router'
import { isAbasteceBiz, showRtboStore } from '@/common/utils/BizUtils'
import { getBDCountry } from '@/common/utils/i18n'

// console.log('[log] x-router init', window, window.Soda, window.Soda.toggleTitleBar)
initXRouter(Router, {
  isEnabledNativeRouter: canOpenPageForNewWebview,
})
// import SignForm from '@/pages/sign/SignForm.vue'
const SignIndex = async () => await import(/* webpackChunkName: 'sign' */ '@/pages/sign/index')
const SignIndexBR = async () => await import(/* webpackChunkName: 'sign' */ '@/pages-BR/sign/index')
const SignIndexJP = async () => await import(/* webpackChunkName: 'sign' */ '@/pages-JP/sign/index')
const SignIndexCOM = async () =>
  await import(/* webpackChunkName: 'sign' */ '@/pages-COM/sign/index')

const SnapshotInfo = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages/sign/SnapshotInfo')
const SnapshotInfoBR = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-BR/sign/SnapshotInfo')
const SnapshotInfoJP = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-JP/sign/SnapshotInfo')
const SnapshotInfoCOM = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-COM/sign/SnapshotInfo')

const SignFormBR = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-BR/sign/SignForm.vue')
const SignFormJP = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-JP/sign/SignForm.vue')
const SignForm = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages/sign/SignForm.vue')
const SignFormCOM = async () =>
  await import(/* webpackChunkName: 'sign-snapshot-info' */ '@/pages-COM/sign/SignForm.vue')

const EditBizopp = async () =>
  await import(/* webpackChunkName: 'bizopp.edit' */ '@/pages/editBizopp/index')
const EditBizoppBR = async () =>
  await import(/* webpackChunkName: 'bizopp.edit' */ '@/pages-BR/editBizopp/index')
const EditBizoppJP = async () =>
  await import(/* webpackChunkName: 'bizopp.edit' */ '@/pages-JP/editBizopp/index')
const EditBizoppCOM = async () =>
  await import(/* webpackChunkName: 'bizopp.edit' */ '@/pages-COM/editBizopp/index')

const AddVisit = async () =>
  await import(/* webpackChunkName: 'visit' */ '@/pages/visit/addvisit/index')

// 拜访详情
const visitDetail = async () =>
  await import(/* webpackChunkName: 'visit' */ '@/pages/visit/detail20')
const visitDetailBR = async () =>
  await import(/* webpackChunkName: 'visit' */ '@/pages-BR/visit/detail20')
const visitDetailJP = async () =>
  await import(/* webpackChunkName: 'visit' */ '@/pages-JP/visit/detail20')
const visitDetailCOM = async () =>
  await import(/* webpackChunkName: 'visit' */ '@/pages-COM/visit/detail20')

// 我的拜访
const myvisit = async () => await import(/* webpackChunkName: 'visit' */ '@/pages/visit/myvisit')

// 商家信息录入-目前只有日本有该功能  2020-04-21
const shopInfoCollectJP = async () =>
  await import(/* webpackChunkName: 'shop-info-collect' */ '@/pages-JP/shopInfoCollect/index')
const shopInfoCollectDetailJP = async () =>
  await import(/* webpackChunkName: 'shop-info-collect' */ '@/pages-JP/shopInfoCollect/detail')

// 展示银行卡示例-目前只有巴西有该功能
const showBankCardExample = async () =>
  await import(/* webpackChunkName: 'sign' */ '@/pages-BR/sign/BankCardExample.vue')

// BR-新建陪访
const addAccompanyVisitBR = async () =>
  await import(
    /* webpackChunkName: 'addAccompanyVisitBR' */ '@/pages-BR/accompanyVisit/page/visit-add'
  )

// BR-关联拜访记录列表
const visitListBR = async () =>
  await import(/* webpackChunkName: 'visitListBR' */ '@/pages-BR/accompanyVisit/page/VisitList')

// BR-陪访计划列表
const accompanyVisitPlanListBR = async () =>
  await import(
    /* webpackChunkName: 'accompanyVisitPlanListBR' */ '@/pages-BR/accompanyVisit/page/VisitPlanList'
  )

// COM-新建拜访
const addAccompanyVisit = async () =>
  await import(
    /* webpackChunkName: 'addAccompanyVisit' */ '@/pages-v2/accompanyVisit/page/VisitAdd'
  )

// COM-关联拜访记录列表
const visitList = async () =>
  await import(
    /* webpackChunkName: 'visitList' */
    '@/pages-v2/accompanyVisit/page/VisitList'
  )
// COM-拜访计划列表
const accompanyVisitPlanList = async () =>
  await import(
    /* webpackChunkName: 'accompanyVisitPlanList' */
    '@/pages-v2/accompanyVisit/page/VisitPlanList'
  )

Vue.use(Router)

// 针对需要返回特定页面的情况，在路由query上加上mark标识
Router.prototype.queryReplace = function ({
  mark = '',
  queryObj = {},
  targetPath = '',
  params = {},
}) {
  Object.values(queryObj).forEach(item => {
    if (mark === item) {
      this.replace({
        path: targetPath,
        query: queryObj,
        params,
      })
    }
  })
  // 如果没有匹配到则返回上一页
  if (!Object.values(queryObj).includes(mark)) {
    if (Soda.closePage) {
      Soda.closePage({})
    } else {
      if (window.Soda.goBack) {
        window.Soda.goBack({}, () => {})
      } else {
        this.isBack = true
        this.back()
      }
    }
  }
}
const diffPageConfig = {
  BR: {
    SnapshotInfo: SnapshotInfoBR,
    SignForm: SignFormBR,
    SignIndex: SignIndexBR,
    EditBizopp: EditBizoppBR,
    shopDetail: shopDetailBR,
    visitDetail: visitDetailBR,
    addAccompanyVisit: addAccompanyVisitBR,
    accompanyVisitPlanList: accompanyVisitPlanListBR,
    visitList: visitListBR,
  },
  COM: {
    SnapshotInfo: SnapshotInfoCOM,
    SignForm: SignFormCOM,
    SignIndex: SignIndexCOM,
    EditBizopp: EditBizoppCOM,
    shopDetail: shopDetailCOM,
    visitDetail: visitDetailCOM,
    addAccompanyVisit,
    accompanyVisitPlanList,
    visitList,
  },
  MX: {
    SnapshotInfo,
    SignForm,
    SignIndex,
    EditBizopp,
    shopDetail,
    visitDetail,
    addAccompanyVisit,
    accompanyVisitPlanList,
    visitList,
  },
  JP: {
    SnapshotInfo: SnapshotInfoJP,
    SignForm: SignFormJP,
    SignIndex: SignIndexJP,
    EditBizopp: EditBizoppJP,
    shopDetail: shopDetailJP,
    visitDetail: visitDetailJP,
    shopInfoCollect: shopInfoCollectJP,
    shopInfoCollectDetail: shopInfoCollectDetailJP,
  },
}

const getPageInfo = (country, attr) => {
  /** 巴西墨西哥日本走原来的，新开国的配置走COM这个配置的 */
  if (defaultExistTag.indexOf(country) !== -1) {
    return diffPageConfig[country][attr]
  }
  const dt = diffPageConfig.COM[attr] || diffPageConfig.MX[attr]
  return dt
}
const router = function (country) {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '*',
        name: 'notFound',
        component: NotFound,
      },
      {
        path: '/',
        redirect: isAbasteceBiz() ? 'v2/home/visitTask' : 'v2/home/workbench',
      },
      {
        path: '/home',
        redirect: isAbasteceBiz() ? 'v2/home/visitTask' : 'v2/home/workbench',
      },
      {
        path: '/home/summary',
        name: 'summary',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'home' */
              '@/pages/home/summarypage'
            ),
          )
        },
      },
      {
        path: '/home/list',
        redirect: showRtboStore() ? '/v2/home/rtboStore' : '/v2/home/priorityStore',
      },
      {
        path: '/home/visitTask',
        redirect: '/v2/home/visitTask',
      },
      {
        path: '/home/:page',
        name: 'home',
        redirect: '/v2/home/:page',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'home' */
              '@/pages/home/index'
            ),
          )
        },
      },
      {
        path: '/blankpage',
        name: 'Blankpage',
        component: () =>
          import(/* 空白埋点页 */ '@/pages-v2/MessageCenter/pages/TopSailingBlankPage.vue'),
        meta: {
          requiresAuth: false, // 设置该页面不需要登录验证
        },
      },
      {
        path: '/task/detail/:id',
        name: 'TaskName',
        component: () => import(/* webpackChunkName: 'TaskName' */ '@/pages/home/taskDetail'),
      },
      {
        path: '/task/transact/:id',
        name: 'TaskTransact',
        component: () => import(/* webpackChunkName: 'TaskTransact' */ '@/pages/home/transactor'),
      },
      {
        path: '/home-quick-list/:type',
        name: 'homeQuickList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'home' */
              '@/pages/home/quickList'
            ),
          )
        },
      },
      {
        path: '/edit-bizopp',
        name: 'editBizopp',
        component: getPageInfo(country, 'EditBizopp'),
      },
      {
        path: '/add-bizopp',
        name: 'addBizopp',
        component: getPageInfo(country, 'EditBizopp'),
      },
      {
        path: '/add-bizopp-sme',
        name: 'addBizoppSME',
        component: () =>
          import(/* webpackChunkName: 'editBizoppSME' */ '@/pages/editBizoppSME/index'),
      },
      {
        path: '/giveup-bizopp',
        name: 'giveUpBizopp',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'giveUpBizopp' */
              '@/pages/giveupBizopp/index'
            ),
          )
        },
      },
      {
        path: '/search',
        name: 'searchShop',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'search' */
              '@/pages/search/index'
            ),
          )
        },
      },
      {
        path: '/map',
        name: 'map',
        redirect: '/v2/map',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'map' */
              '@/pages/map/index'
            ),
          )
        },
      },
      {
        path: '/new-bizopp/:page',
        name: 'newBizopp',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'bizopp.new' */
              '@/pages/newBizopp/index'
            ),
          )
        },
      },
      {
        path: '/sign/bankCard',
        name: 'bankCard',
        props: true,
        component: showBankCardExample,
      },
      {
        path: '/sign/:id/:type/snapshot-info',
        name: 'snapshot',
        props: true,
        component: getPageInfo(country, 'SnapshotInfo'),
      },
      {
        path: '/sign/:id/:type/:name',
        name: 'signDynamicForm',
        props: true,
        component: getPageInfo(country, 'SignForm'),
      },
      {
        path: '/sign/:id/:type',
        name: 'sign',
        props: true,
        component: getPageInfo(country, 'SignIndex'),
      },
      {
        path: '/user',
        name: 'user',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'user' */
              '@/pages/user/index'
            ),
          )
        },
      },
      {
        path: '/lang',
        name: 'lang',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'lang' */
              '@/pages/lang/index'
            ),
          )
        },
      },
      {
        path: '/about',
        name: 'about',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'about' */
              '@/pages/about/index'
            ),
          )
        },
      },
      {
        path: '/add-visit',
        name: 'addVisit',
        component: AddVisit,
      },
      {
        path: '/add-visit-plan',
        name: 'addVisitplan',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'visit' */
              '@/pages/visit/addvisitplan/index'
            ),
          )
        },
      },
      {
        path: '/visit-list',
        name: 'visitList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'visit' */
              '@/pages/visit/list'
            ),
          )
        },
      },
      {
        path: '/visit-detail',
        name: 'visitDetail',
        component: getPageInfo('MX', 'visitDetail'),
        // async component (resolve) {
        //   resolve(
        //     await import(/* webpackChunkName: 'visit' */
        //     '@/pages/visit/detail20')
        //   )
        // }
      },
      {
        path: '/my-visit', // 我的拜访
        name: 'myVisit',
        component: myvisit,
        meta: {
          keepAlive: true, // 需要被缓存
        },
      },
      {
        path: '/visit-person',
        name: 'visitPerson',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'visit' */
              '@/pages/visit/visitperson'
            ),
          )
        },
      },
      {
        path: '/add-visit-person',
        name: 'addVisitPerson',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'addVisitPerson' */
              '@/pages/visit/visitperson/AddVisitPerson'
            ),
          )
        },
      },
      {
        path: '/edit-visit-person',
        name: 'editVisitPerson',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'addVisitPerson' */
              '@/pages/visit/visitperson/AddVisitPerson'
            ),
          )
        },
      },
      {
        path: '/edit-busi-info',
        name: 'editBusiInfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'editBusiInfo' */
              '@/pages/editBusiInfo/index'
            ),
          )
        },
      },
      {
        path: '/v2/contact-info', // 巴西 联系人信息列表
        name: 'contactInfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'editBusiInfo' */
              '@/pages-v2/contactInfo/index'
            ),
          )
        },
      },
      {
        path: '/v2/contact-form', // 巴西 新建联系人表单页
        name: 'contactInfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'editBusiInfo' */
              '@/pages-v2/contactInfo/form'
            ),
          )
        },
      },
      {
        path: '/view-survey-info',
        name: 'viewSurveyInfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'viewSurveyInfo' */
              '@/pages/viewSurveyInfo/index'
            ),
          )
        },
      },
      {
        path: '/edit-survey-info',
        name: 'editSurveyInfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'editSurveyInfo' */
              '@/pages/editSurveyInfo/index'
            ),
          )
        },
      },
      {
        path: '/shop-info-collect',
        name: 'shopInfoCollect',
        component: getPageInfo(country, 'shopInfoCollect'),
      },
      {
        path: '/shop-info-collect/detail',
        name: 'shopInfoCollectDetail',
        component: getPageInfo(country, 'shopInfoCollectDetail'),
      },
      ...getPageInfo(country, 'shopDetail'),
      {
        path: '/businessinfo',
        name: 'businessinfo',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'editBusiInfo' */
              '@/pages/editBusiInfo/collect'
            ),
          )
        },
      },
      {
        path: '/v2/party/sign/:id/:type',
        name: 'partySign',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'party.sign' */
              '@/pages-v2/party/sign/index'
            ),
          )
        },
      },
      {
        path: '/v2/party/relation/relatedSub/:id/:type',
        name: 'relatedSub',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'partyRelation' */
              '@/pages-v2/party/relation/relatedSub'
            ),
          )
        },
      },
      {
        path: '/v2/party/relation/relationShop/:id/:type',
        name: 'relationShop',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'relationShop' */
              '@/pages-v2/party/relation/relationShopList'
            ),
          )
        },
      },
      {
        path: '/v2/party/relation/relationNewShop/:id',
        name: 'relationNewShop',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'relationNewShop' */
              '@/pages-v2/party/relation/relationNewShop'
            ),
          )
        },
      },
      {
        path: '/v2/party/sign/:id/:type/:name',
        name: 'partySignDynamicForm',
        props: true,
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'partySign' */
              '@/pages-v2/party/sign/SignForm'
            ),
          )
        },
      },
      {
        path: '/v2/shop/sign/:id/:type',
        name: 'shopSign',
        props: true,
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'partySign' */
              '@/pages-v2/shop/sign/index'
            ),
          )
        },
      },
      {
        path: '/v2/shop/sign/SnapshotInfo/:id/:type',
        name: 'SnapshotInfo',
        props: true,
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'partySign' */
              '@/pages-v2/shop/sign/SnapshotInfo'
            ),
          )
        },
      },
      {
        path: '/v2/shop/sign/:id/:type/:name',
        name: 'shopSignDynamicForm',
        props: true,
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'partySign' */
              '@/pages-v2/shop/sign/SignForm'
            ),
          )
        },
      },
      /**
       * 以下为V2版重构的新路由，需要统一加前缀 /v2/
       */
      {
        path: '/v2/search',
        name: 'searchStore',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'search' */
              '@/pages-v2/SearchStore/views/search.vue'
            ),
          )
        },
      },
      {
        path: '/v2/search-result',
        name: 'searchResult',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'search' */
              '@/pages-v2/SearchStore/views/result.vue'
            ),
          )
        },
      },
      {
        path: '/v2/bizopp-detail',
        name: 'BizoppDetailV2',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'BizoppDetailV2' */
              '@/pages-v2/ShopDetail/bizoppV2.vue'
            ),
          )
        },
      },
      {
        path: '/v2/shop-detail',
        name: 'ShopDetailV2',
        async component(resolve) {
          resolve(await import(/* webpackChunkName: 'ShopDetailV2' */ '@/pages-v2/ShopDetail/new'))
        },
      },
      {
        path: '/v2/shop-detail/base-detail',
        name: 'ShopBaseDetailV2',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'ShopBaseDetailV2' */ '@/pages-v2/ShopDetail/pages/shopBaseDetail'
            ),
          )
        },
      },
      // 菜品列表页
      {
        path: '/v2/dish-list',
        name: 'DishListV2',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'DishListV2' */
              '@/pages-v2/Dish/index'
            ),
          )
        },
      },
      // 绩效店铺列表页
      // {
      //   path: '/v2/performance',
      //   name: 'performance'
      // async component (resolve) {
      //   resolve(
      //     await import(/* webpackChunkName: 'performance' */
      //       '@/pages-v2/performance/index')
      //   )
      // }
      // },
      // 营销活动入口页面
      {
        path: '/v2/promo-activity',
        name: 'promo-activity',
        async component(resolve) {
          resolve(await import(/* webpackChunkName: 'DishListV2' */ '@/pages-v2/Promotion/index'))
        },
      },
      // 物料管理入口页面
      {
        path: '/v2/material-management',
        name: 'material-management',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'MaterialManagementV2' */ '@/pages-v2/MaterialManagement/index'
            ),
          )
        },
      },
      // bd检查列表页
      {
        path: '/v2/bd-check-list',
        name: 'bd-check-list',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'DishListV2' */ '@/pages-v2/ShopDetail/pages/BDCheckList/index'
            ),
          )
        },
      },
      {
        path: '/v2/merchants-pre-registration',
        name: 'merchants-pre-registration',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'DishListV2' */ '@/pages-v2/ShopDetail/pages/MerchantsPreRegistration/index'
            ),
          )
        },
      },
      {
        path: '/v2/select-item',
        name: 'select-item',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'DishListV2' */ '@/pages-v2/ShopDetail/pages/SelectItem/index'
            ),
          )
        },
      },
      {
        path: '/v2/performance-search',
        name: 'performance-search',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'performance-search' */
              '@/pages-v2/performance-search/index'
            ),
          )
        },
      },
      {
        path: '/v2/store-compare',
        name: 'store-compare',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'store-compare' */
              '@/pages-v2/ShopDetail/pages/StorePerformanceCompare/index'
            ),
          )
        },
      },
      {
        path: '/v2/store-compare-list',
        name: 'store-compare-list',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'store-compare-list' */
              '@/pages-v2/ShopDetail/pages/CompareStoreList/index'
            ),
          )
        },
      },
      {
        path: '/v2/add-accompany-visit',
        name: 'addAccompanyVisit',
        component: getPageInfo(country, 'addAccompanyVisit'),
      },
      {
        path: '/v2/add-accompany-visit-formily',
        name: 'addAccompanyVisitFormily',
        component: () =>
          import(
            /* webpackChunkName: 'addAccompanyVisitFormily' */ '@/pages-v2/accompanyVisit/page/VisitAddFormily/index.vue'
          ),
      },
      {
        path: '/v2/accompany-visit-list',
        name: 'accompanyVisitList',
        component: getPageInfo(country, 'visitList'),
      },
      {
        path: '/v2/accompany-visit-list-formily',
        name: 'accompanyVisitListFormily',
        component: () =>
          import(
            /* webpackChunkName: 'visitListFormily' */ '@/pages-v2/accompanyVisit/page/VisitAddFormily/VisitList.vue'
          ),
      },
      {
        path: '/v2/accompany-visitplan-list',
        name: 'accompanyVisitPlanList',
        component: getPageInfo(country, 'accompanyVisitPlanList'),
      },
      {
        path: '/v2/dishes-match-detail',
        name: 'dishesMatchDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'dishesMatchDetail' */
              '@/pages-v2/home/ProjectAction/DishesMatch/detail'
            ),
          )
        },
      },
      {
        path: '/v2/detail-visit-record',
        name: 'detail-visit-record',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'detail-visit-record' */
              '@/pages-v2/Visit/pages/record.vue'
            ),
          )
        },
      },
      {
        path: '/v2/detail-shop-visit-record',
        name: 'detail-shop-visit-record',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'detail-visit-record' */
              '@/pages-v2/Visit/pages/shopRecord.vue'
            ),
          )
        },
      },
      {
        path: '/v2/violationManage',
        name: 'violationManage',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'violationManage' */
              '@/pages-v2/violation/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/violationDetail',
        name: 'violationDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'violationDetail' */
              '@/pages-v2/violation/detail.vue'
            ),
          )
        },
      },
      {
        path: '/v2/violationAppeal',
        name: 'violationAppeal',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'violationAppeal' */
              '@/pages-v2/violation/appeal.vue'
            ),
          )
        },
      },
      {
        path: '/v2/violationResolve',
        name: 'violationResolve',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'violationResolve' */
              '@/pages-v2/violation/resolve.vue'
            ),
          )
        },
      },
      {
        path: '/v2/home/:page',
        name: 'v2/home',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'home' */
              '@/pages-v2/home/index'
            ),
          )
        },
      },
      {
        path: '/v2/promoList',
        name: 'promo-list',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'promo-list' */
              '@/pages-v2/home/promoList/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/user',
        name: 'UserV2',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'UserV2' */
              '@/pages-v2/home/More/pages/User'
            ),
          )
        },
      },
      {
        path: '/v2/guide',
        name: 'v2/guide',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'guide' */
              '@/pages-v2/Guide/index'
            ),
          )
        },
      },
      {
        path: '/v2/survey',
        name: 'Survey',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'Survey' */
              '@/pages-v2/home/survey/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/message-survey-list',
        name: 'messageSurveyList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'messageSurveyList' */
              '@/pages-v2/MessageCenter/pages/MessageSurveyList.vue'
            ),
          )
        },
      },
      {
        path: '/v2/message-center',
        name: 'messageCenter',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'messageCenter' */
              '@/pages-v2/MessageCenter/pages/MessageList.vue'
            ),
          )
        },
      },
      {
        path: '/v2/message-list',
        name: 'messageList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'messageList' */
              '@/pages-v2/MessageCenter/pages/MessageDetailList.vue'
            ),
          )
        },
      },
      {
        path: '/v2/map',
        name: 'v2/map',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'map' */
              '@/pages-v2/Map/index'
            ),
          )
        },
      },
      {
        path: '/v2/add-visit-new',
        name: 'v2/addVisitNew',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'addVisitV2' */
              '@/pages-v2/Visit/pages/addVisitV2/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/add-visit',
        name: 'v2/addVisit',
        async component(resolve) {
          const country = getBDCountry()
          // 巴西的页面
          if (country === 'BR') {
            console.log(
              '%c 🇧🇷 %c[log] => 巴西 @/pages-v2/VisitBR/pages/addVisit/index',
              'font-size: 16px;',
              'color: #4CAF50; font-weight: bold;',
            )
            resolve(
              await import(
                /* webpackChunkName: 'VisitBR/pages/addVisitV2' */
                '@/pages-v2/VisitBR/pages/addVisit/index'
              ),
            )
          } else {
            // 其他国家的页面
            resolve(
              await import(
                /* webpackChunkName: 'addVisitV2' */
                '@/pages-v2/Visit/pages/addVisit/index'
              ),
            )
          }
        },
      },
      {
        path: '/v2/add-visit-plan',
        name: 'v2/addVisitPlan',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            console.log(
              '%c 🇧🇷 %c[log] => 巴西 @/pages-v2/VisitBR/pages/addVisitPlan/index',
              'font-size: 16px;',
              'color: #4CAF50; font-weight: bold;',
            )
            resolve(
              await import(
                /* webpackChunkName: 'VisitBR/pages/addVisitPlan' */ '@/pages-v2/VisitBR/pages/addVisitPlan/index'
              ),
            )
          } else {
            resolve(
              await import(
                /* webpackChunkName: 'addVisitPlanV2' */ '@/pages-v2/Visit/pages/addVisitPlan/index'
              ),
            )
          }
        },
      },
      {
        path: '/v2/visit-record',
        name: 'v2/visitRecord',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            console.log(
              '%c 🇧🇷 %c[log] => 巴西 @/pages-v2/VisitBR/pages/visitRecord/index',
              'font-size: 16px;',
              'color: #4CAF50; font-weight: bold;',
            )
            resolve(
              await import(
                /* webpackChunkName: 'VisitBR/pages/visitRecord' */ '@/pages-v2/VisitBR/pages/visitRecord/index'
              ),
            )
          } else {
            resolve(
              await import(
                /* webpackChunkName: 'visitRecord' */ '@/pages-v2/Visit/pages/visitRecord/index'
              ),
            )
          }
        },
      },
      {
        path: '/v2/visit-plan-record',
        name: 'v2/visitPlanRecord',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            console.log(
              '%c 🇧🇷 %c[log] => 巴西 @/pages-v2/VisitBR/pages/visitPlanRecord/index',
              'font-size: 16px;',
              'color: #4CAF50; font-weight: bold;',
            )
            resolve(
              await import(
                /* webpackChunkName: 'VisitBR/pages/visitPlanRecord' */ '@/pages-v2/VisitBR/pages/visitPlanRecord/index'
              ),
            )
          } else {
            resolve(
              await import(
                /* webpackChunkName: 'visitPlanRecord' */ '@/pages-v2/Visit/pages/visitPlanRecord/index'
              ),
            )
          }
        },
      },
      /* 以下是油站路由 */
      {
        path: '/gas/search',
        name: 'gasSearch',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasSearch' */
              '@/pages-v2/Gas/SearchStoreGas/views/search.vue'
            ),
          )
        },
      },
      {
        path: '/gas/search-result',
        name: 'gasSearchResult',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasSearchResult' */
              '@/pages-v2/Gas/SearchStoreGas/views/result.vue'
            ),
          )
        },
      },
      {
        path: '/gas/shop-detail',
        name: 'gasShopDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasShopDetail' */
              '@/pages-v2/Gas/ShopDetailGas/index.vue'
            ),
          )
        },
      },
      {
        path: '/gas/edit-bizopp',
        name: 'gasEditBizopp',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasmap' */
              '@/pages-v2/Gas/ShopDetailGas/page/EditGasBizopp/index'
            ),
          )
        },
      },
      {
        path: '/gas/add-visit',
        name: 'gasAddVisit',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasAddVisit' */
              '@/pages-v2/Gas/VisitGas/pages/addVisit/index.vue'
            ),
          )
        },
      },
      {
        path: '/gas/cost-price-detail',
        name: 'gasCostPriceDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasAddVisit' */
              '@/pages-v2/Gas/ShopDetailGas/page/CostPriceDetail/index.vue'
            ),
          )
        },
      },
      {
        path: '/gas/detail-visit-record',
        name: 'gasDetailVisitRecord',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasAddVisit' */
              '@/pages-v2/Gas/VisitGas/pages/record.vue'
            ),
          )
        },
      },
      {
        path: '/gas/visit-record',
        name: 'gasVisitRecord',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasAddVisit' */
              '@/pages-v2/Gas/VisitGas/pages/visitRecord/index.vue'
            ),
          )
        },
      },
      {
        path: '/gas/add-new-visit-plan',
        name: 'gasAddNewVisitPlan',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'gasAddVisit' */
              '@/pages-v2/Gas/VisitGas/pages/visitRecord/index.vue'
            ),
          )
        },
      },
      {
        path: '/gas/map',
        name: 'gasMap',
        async component(resolve) {
          resolve(await import(/* webpackChunkName: 'gasmap' */ '@/pages-v2/Gas/MapGas/index'))
        },
      },
      {
        path: '/v2/salesTask',
        name: 'salesTask',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            resolve(
              await import(
                /* webpackChunkName: 'home/salesTaskBR/index.vue' */ '@/pages-v2/home/salesTaskBR/index.vue'
              ),
            )
          } else {
            resolve(
              await import(
                /* webpackChunkName: 'salesTask' */
                '@/pages-v2/home/salesTask/index.vue'
              ),
            )
          }
        },
      },
      {
        path: '/v2/taskDetail',
        name: 'taskDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'taskDetail' */
              '@/pages-v2/home/salesTask/detail.vue'
            ),
          )
        },
      },
      {
        path: '/v2/shopTaskList',
        name: 'shopTaskList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'shopTaskList' */
              '@/pages-v2/home/salesTask/shopTaskList.vue'
            ),
          )
        },
      },
      {
        path: '/v2/newShopTaskList',
        name: 'newShopTaskList',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            resolve(await import('@/pages-v2/home/salesTaskBR/shopTaskList.vue'))
          } else {
            resolve(await import('@/pages-v2/home/salesTask/newShopTaskList.vue'))
          }
        },
      },
      {
        path: '/v2/createTask',
        name: 'createTask',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'shopTaskList' */
              '@/pages-v2/home/salesTask/createTask.vue'
            ),
          )
        },
      },
      {
        path: '/v2/project-action',
        name: 'projectAction',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'projectAction' */ '@/pages-v2/home/ProjectAction/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/project-action-detail',
        name: 'projectActionDetail',
        async component(resolve) {
          const country = getBDCountry()
          if (country === 'BR') {
            resolve(
              await import(
                /* webpackChunkName:'projectActionDetail' */ '@/pages-v2/home/salesTaskBR/detail.vue'
              ),
            )
          } else {
            resolve(
              await import(
                /* webpackChunkName:'projectActionDetail' */ '@/pages-v2/home/ProjectAction/detail.vue'
              ),
            )
          }
        },
      },
      {
        path: '/v2/download',
        name: 'download',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'shopTaskList' */
              '@/pages-v2/download/index.vue'
            ),
          )
        },
      },
      {
        path: '/v2/market-calculator',
        name: 'market-calculator',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'market-calculator' */ '@/pages-v2/ShopDetail/pages/MarketCalculator/index'
            ),
          )
        },
      },
      {
        path: '/v2/feedback',
        name: 'feedback',
        async component(resolve) {
          resolve(await import(/* webpackChunkName: 'feedback' */ '@/pages-v2/feedback/index'))
        },
      },
      {
        path: '/v2/feedback/history',
        name: 'feedbackHistoryList',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'feedbackHistoryList' */ '@/pages-v2/feedback/historyList'
            ),
          )
        },
      },
      {
        path: '/v2/feedback/detail',
        name: 'feedbackDetail',
        async component(resolve) {
          resolve(
            await import(
              /* webpackChunkName: 'feedbackDetail' */ '@/pages-v2/feedback/feedbackDetail'
            ),
          )
        },
      },
    ],
  })
}

export default router
